import type { Account } from 'pkg/api/models/account';
import { yearsSince } from 'pkg/date';

export function fullName(account: Account): string {
	return `${account.firstName} ${account.lastName}`;
}

export function initials(account: Account): string {
	return `${account.firstName.substring(0, 1)}${account.lastName.substring(
		0,
		1
	)}`;
}

export function age(account: Account): number {
	return yearsSince(new Date(account.birthDate));
}
